import { sendGTMEvent } from "@next/third-parties/google";
import type { StorePassengersSchemaType } from "../schemas/tour/storePassengersSchema";
import type { StorePassengersSchema } from "../schemas/hotel/storePassengersSchema";
import type { PassengersSchemaType } from "../schemas/flight/passengersSchema";

class GMT<Product, Form, Payment> {
  private eventNames: {
    selectProduct: string;
    submitForm: string;
    submitPayment: string;
  };
  constructor(eventNames: {
    selectProduct: string;
    submitForm: string;
    submitPayment: string;
  }) {
    this.eventNames = eventNames;
  }
  selectProduct(data: Product) {
    sendGTMEvent({ ...data, event: this.eventNames.selectProduct });
  }

  submitForm(data: Form) {
    sendGTMEvent({ ...data, event: this.eventNames.submitForm });
  }
  submitPayment(data: Payment) {
    sendGTMEvent({ ...data, event: this.eventNames.submitPayment });
  }
}

const flightGTM = new GMT<
  FlightSelect,
  FormSubmit<PassengersSchemaType["passengers"]>,
  PaymentCheck
>({
  selectProduct: "selectFlight",
  submitForm: "submitFlightForm",
  submitPayment: "submitFlightPayment",
});
const hotelGTM = new GMT<
  HotelSelect,
  FormSubmit<StorePassengersSchema["rooms"]>,
  PaymentCheck
>({
  selectProduct: "selectHotel",
  submitForm: "submitHotelForm",
  submitPayment: "submitHotelPayment",
});
const tourGTM = new GMT<
  TourSelect,
  FormSubmit<StorePassengersSchemaType["rooms"]>,
  PaymentCheck
>({
  selectProduct: "selectTour",
  submitForm: "submitTourForm",
  submitPayment: "submitTourPayment",
});

export default GMT;

export { flightGTM, hotelGTM, tourGTM };
